<template>
  <div class='container'>
    <div class="user-profile">
      <div class="info">
        <van-image round fit="cover" :src="user.photo" />
        <h3 class="name">{{user.name}}</h3>
        <RouterLink class="btn" to="/user/profile">个人信息</RouterLink>
      </div>
      <van-row>
        <van-col span="6" @click="$router.push('/user/dynamic')">
          <p>{{user.art_count}}</p>
          <p>动态</p>
        </van-col>
        <van-col span="6" @click="$router.push('/user/fans?type=follow')">
          <p>{{user.follow_count}}</p>
          <p>关注</p>
        </van-col>
        <van-col span="6" @click="$router.push('/user/fans?type=fans')">
          <p>{{user.fans_count}}</p>
          <p>粉丝</p>
        </van-col>
        <van-col span="6">
          <p>{{user.like_count}}</p>
          <p>被赞</p>
        </van-col>
      </van-row>
      <van-row class="user-links">
        <van-col span="6">
          <tt-icon @click="$router.push('/user/message')" name="message"/>消息通知
        </van-col>
        <van-col span="6">
          <tt-icon @click="$router.push('/user/article?type=2')" name="mycollect"/>我的收藏
        </van-col>
        <van-col span="6">
          <tt-icon @click="$router.push('/user/article?type=3')" name="history"/>阅读历史
        </van-col>
        <van-col span="6">
          <tt-icon @click="$router.push('/user/article?type=1')" name="myworks"/>我的作品
        </van-col>
      </van-row>
    </div>
    <div class="more">
      <p>更多服务</p>
      <van-row>
        <van-col span="6">
          <tt-icon @click="$router.push('/user/feedback')" name="feedback2"/>用户反馈
        </van-col>
        <van-col span="6">
          <tt-icon @click="$router.push('/user/chat')" name="xiaozhi"/>小智同学
        </van-col>
        <van-col span="6">
        </van-col>
        <van-col span="6">
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/user'
import { mapMutations } from 'vuex'
export default {
  name: 'UserHome',
  data () {
    return {
      user: {}
    }
  },
  created () {
    this.getUserInfo()
  },
  activated () {
    this.getUserInfo()
  },
  methods: {
    ...mapMutations(['setPhoto']),
    async getUserInfo () {
      const data = await getUserInfo()
      this.user = data
      // 更新vuex用户头像
      this.setPhoto(data.photo)
    }
  }
}
</script>

<style scoped lang='less'>
.container {
  background: #f8f8f8;
  height: 100%;
}
.more {
  margin: 0 15px;
  background-color: #fff;
  border-radius: 10px;
  height: 120px;
  p {
    font-size: 16px;
    padding: 10px 15px;
  }
  .van-row {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    .tt-icon {
      display: block;
      font-size: 22px;
      padding-bottom: 5px;
    }
  }
}
.user {
  &-profile {
    width: 100%;
    padding: 0 15px;
    height: 240px;
    display: block;
    background: linear-gradient(318deg,#B2B5DB 0%,#565482 70%,#494675 100%);
    color: #fff;
    border-bottom-left-radius: 400px 60px;
    border-bottom-right-radius: 400px 60px;
    margin-bottom: 48px;
    .info {
      display: flex;
      padding: 40px 0;
      height: 130px;
      align-items: center;
      .van-image {
        width: 50px;
        height: 50px;
        border: 3px solid #7674a2;
      }
      .name {
        font-size: 20px;
        font-weight: normal;
        margin-left: 10px;
        flex: 1;
      }
      .btn {
        color: #fff;
        line-height: 1;
        font-size: 12px;
        &::after {
          font: normal normal normal 0.37333rem/1 'vant-icon';
          content: '\F00A';
          position: relative;
          top: 1px;
          left: 2px;
          font-size: 12px;
        }
      }
    }
    p {
      margin: 0;
      text-align: center;
      height: 20px;
    }
  }
  &-links {
    padding: 20px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    color: #333;
    position: relative;
    top: 20px;
    .tt-icon {
      display: block;
      font-size: 22px;
      padding-bottom: 5px;
    }
  }
}
</style>
